import { freightFormMessages } from '../../../freight-browser/components/freight-form/freight-form-messages';

import type { ServicesGridField } from './ServicesGrid';
import type { LtlPickupServices } from '../../../../types/ship-from';

/**
 * The nine pickup-service checkboxes shared between the Booking Wizard's Ship
 * From step and the Ship From Location "Freight Defaults" settings section.
 *
 * Defined here (not inside ShipFromStep) so both surfaces reuse the identical
 * array — label drift between wizard and settings is structurally impossible.
 */
export const PICKUP_SERVICE_FIELDS: ServicesGridField<LtlPickupServices>[] = [
  { key: 'isInsidePickup', label: freightFormMessages.accessorialInsidePickup },
  { key: 'isConstructionSitePickup', label: freightFormMessages.accessorialConstructionSitePickup },
  { key: 'isLiftgatePickup', label: freightFormMessages.accessorialLiftgatePickup },
  { key: 'isNotifyBeforePickup', label: freightFormMessages.accessorialNotifyBeforePickup },
  { key: 'isResidentialPickup', label: freightFormMessages.accessorialResidentialPickup },
  { key: 'isDropAtTerminal', label: freightFormMessages.accessorialDropShipmentAtTerminal },
  { key: 'isGroceryConsolidationPickup', label: freightFormMessages.accessorialGroceryConsolidationPickup },
  { key: 'isLimitedAccess', label: freightFormMessages.accessorialLimitedAccess },
  { key: 'isTradeshowPickup', label: freightFormMessages.accessorialTradeshowPickup },
];
